{% block swag_paypal_pos_getting_started %}
    <mt-card position-identifier="swag-paypal-pos-getting-started"
             :title="$t('swag-paypal-pos.gettingStarted.cardTitle')">

        {% block swag_paypal_pos_getting_started_reader %}
            <sw-container
                    class="swag-paypal-pos-getting-started__container-reader"
                    columns="1fr 3fr"
                    justify="left"
                    align="center">

                {% block swag_paypal_pos_getting_started_reader_image %}
                    <img class="swag-paypal-pos-getting-started__image"
                         :src="assetFilter('swagpaypal/administration/static/img/paypal-pos-reader.png')"
                         :alt="$t('swag-paypal-pos.gettingStarted.readerImageAlt')">
                {% endblock %}

                {% block swag_paypal_pos_getting_started_reader_description %}
                    <div class="swag-paypal-pos-getting-started__description">

                        {% block swag_paypal_pos_getting_started_reader_description_headline %}
                            <div class="swag-paypal-pos-getting-started__description-headline">
                                {{ $t('swag-paypal-pos.gettingStarted.readerHeadline') }}
                            </div>
                        {% endblock %}

                        {% block swag_paypal_pos_getting_started_reader_description_text %}
                            <div class="swag-paypal-pos-getting-started__description-text">
                                {{ $t('swag-paypal-pos.gettingStarted.readerText') }}

                                {% block swag_paypal_pos_getting_started_reader_description_link %}
                                    <sw-external-link :href="$t('swag-paypal-pos.gettingStarted.readerLinkTarget')"
                                                      class="swag-paypal-pos-getting-started__description-text-link">
                                        {{ $t('swag-paypal-pos.gettingStarted.readerLinkText') }}
                                    </sw-external-link>
                                {% endblock %}
                            </div>
                        {% endblock %}
                    </div>
                {% endblock %}
            </sw-container>
        {% endblock %}

        {% block swag_paypal_pos_getting_started_app %}
            <sw-container
                    class="swag-paypal-pos-getting-started__container-app"
                    columns="1fr 3fr"
                    justify="left"
                    align="center">

                {% block swag_paypal_pos_getting_started_app_image %}
                    <img class="swag-paypal-pos-getting-started__image"
                         :src="assetFilter('swagpaypal/administration/static/img/paypal-pos-app.png')"
                         :alt="$t('swag-paypal-pos.gettingStarted.appImageAlt')">
                {% endblock %}

                {% block swag_paypal_pos_getting_started_app_description %}
                    <div class="swag-paypal-pos-getting-started__description ">

                        {% block swag_paypal_pos_getting_started_app_description_headline %}
                            <div class="swag-paypal-pos-getting-started__description-headline">
                                {{ $t('swag-paypal-pos.gettingStarted.appHeadline') }}
                            </div>
                        {% endblock %}

                        {% block swag_paypal_pos_getting_started_app_description_text %}
                            <div class="swag-paypal-pos-getting-started__description-text"
                                 v-html="$t('swag-paypal-pos.gettingStarted.appText')" />
                        {% endblock %}
                    </div>
                {% endblock %}
            </sw-container>
        {% endblock %}
    </mt-card>
{% endblock %}
